import React, {useEffect, useState} from 'react';
import {
    ListItem,
    Icon,
    Sheet,
    PageContent,
    List,
    Block,
    Button
} from 'framework7-react';
import {useTranslation} from "react-i18next";

type Props = {
    currentAtag: string;
    defaultValue: string;
    onChange: (value: string) => void;
};

export const ATagSelector: React.FC<Props> = ({ currentAtag, defaultValue, onChange }) => {
    const {t} = useTranslation();
    const [sheetOpened, setSheetOpened] = useState(false);
    const [isCustomInvalid, setIsCustomInvalid] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [selectionType, setSelectionType] = useState<'default' | 'custom'>(() =>
        currentAtag === defaultValue ? 'default' : 'custom'
    );

    const [selectedValue, setSelectedValue] = useState(currentAtag);
    const [customInput, setCustomInput] = useState(() =>
        currentAtag!== defaultValue ? currentAtag: ''
    );
    const isCustomChecked = selectionType === 'custom';

    const handleSelectDefault = () => {
        setSelectionType('default');
        setSelectedValue(defaultValue);
        onChange(defaultValue);
    };
    const handleCustomToggle = () => {
        setSelectionType('custom');
        if (selectionType !== 'custom') {
            setSelectionType('custom');
            setSelectedValue(customInput);
        }
    };
    const handleCustomInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setCustomInput(val);
        setIsCustomInvalid(val.trim().length === 0);
    };


    const handleInputFocus = () => {
        if (selectionType !== 'custom') {
            setSelectionType('custom');
            setSelectedValue(customInput);
        }
    };

    const handleApply = () => {
        if (isCustomChecked) {
            if (isCustomInvalid) {
                setSheetOpened(true);
                return;
            }
            setSelectedValue(customInput);
            onChange(customInput);
        } else {
            setSelectedValue(defaultValue);
            onChange(defaultValue);
        }

        setSheetOpened(false);
    };


    useEffect(() => {
        if (!currentAtag) {
            onChange(defaultValue);
        }
        // setSelectedValue(currentAtag);
        // if (currentAtag!== defaultValue) {
        //     setCustomInput(currentAtag);
        // }
        // const currentTypeBasedOnProps = currentAtag=== defaultValue ? 'default' : 'custom';
        // if (currentTypeBasedOnProps !== selectionType) {
        //     setSelectionType(currentTypeBasedOnProps);
        // }

    }, [defaultValue]);

    return (
        <List style={{listStyle: 'none'}}>
            <ListItem
                title={t('profile.atag')}
                smartSelect={false}
                link="#"
                onClick={() => setSheetOpened(true)}
            >
                <Icon f7="number" slot="media" />
                {currentAtag}
            </ListItem>

            <Sheet
                opened={sheetOpened}
                onSheetClosed={() => setSheetOpened(false)}
                closeByBackdropClick={false}
                swipeToClose={false}
                backdrop
            >
                <PageContent>
                    <div className="list simple-list">
                        <label className="item-radio item-content">
                            <input
                                type="radio"
                                name="atag"
                                checked={!isCustomChecked}
                                onChange={handleSelectDefault}
                            />
                            <i className="icon icon-radio"></i>
                            <div className="item-inner">
                                <div className="item-title"
                                     style={{
                                         width: '100%',
                                         borderBottom: '1px solid #d0d0d0',
                                         paddingBottom: '10px',
                                     }}
                                >{defaultValue}</div>
                            </div>
                        </label>
                        <label className="item-radio item-content">
                            <input
                                type="radio"
                                name="atag"
                                checked={isCustomChecked}
                                onChange={handleCustomToggle}
                            />
                            <i className="icon icon-radio"></i>
                            <div className="item-inner">
                                <div className="item-input-wrap"
                                     style={{
                                         width: '100%',
                                         border: `1px solid ${isCustomChecked && isCustomInvalid ? 'red' : '#d0d0d0'}`,
                                         borderRadius: '4px',
                                         padding: '5px',
                                     }}
                                >
                                    <input
                                        type="text"
                                        placeholder={t('profile.enterCustomTag', 'Enter custom Atag')}
                                        value={customInput}
                                        onChange={handleCustomInput}
                                        onFocus={handleInputFocus}
                                    />

                                    {errorMessage.length > 0 ?
                                        <div className="input-error-message"
                                             style={{color: 'red', fontSize: '12px', marginTop: '4px'}}>
                                            {errorMessage}
                                        </div> :null
                                    }
                                </div>
                            </div>
                        </label>
                    </div>

                    <Block>
                        <Button
                            fill
                            disabled={isCustomChecked && isCustomInvalid}
                            onClick={handleApply}
                        >
                            {t('profile.confirmAtag', 'Confirm')}
                        </Button>
                    </Block>
                </PageContent>
            </Sheet>
        </List>
    );
};